const sanityClient = require('@sanity/client');

export default async function ({ route, isHMR, $config, store }) {
  try {
    if (isHMR) { return; }
    const {
      query: { preview, documentId }
    } = route;

    if (!preview) {
      store.commit('preview/setPreviewMode', false);
      return;
    }

    const client = sanityClient({
      projectId: $config.api.projectId,
      dataset: $config.api.dataset,
      apiVersion: $config.api.apiVersion,
      useCdn: false,
      token:
        // eslint-disable-next-line
        'sknnbmEBRoNQYNFTDchbHqFc6uTEYc5QDgXOoJEXbASsynzi4FWXQ8SvkJ5j37JlhURGkIfcpYij7KFXcapkiP5mxryjN0m9heCZf8lsU0ft0dnkbqQ3KWceLRJt63JWB8tkDcZO94LpJdVefGWaPOcvrnhPj7Nok0Gko0V0kQkND5L9siQS'
    });

    const query = `*[_id=="${documentId}"][0]`;
    const result = await client.fetch(query);
    store.commit('preview/setPreviewMode', true);
    store.commit('preview/setDocumentData', result || {});
  } catch (e) {
    throw new Error(`previewMode.js: ${e}`);
  }
}
